import validate from "C:/Users/ngngo/Projects/ft_hts_fe/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "C:/Users/ngngo/Projects/ft_hts_fe/src/middleware/auth.global.ts";
import page_45tab_45global from "C:/Users/ngngo/Projects/ft_hts_fe/src/middleware/page-tab.global.ts";
import route_45permission_45check_45global from "C:/Users/ngngo/Projects/ft_hts_fe/src/middleware/route-permission-check.global.ts";
import manifest_45route_45rule from "C:/Users/ngngo/Projects/ft_hts_fe/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  page_45tab_45global,
  route_45permission_45check_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}